<template>
  <div class="row mx-0">
    <div class="col-5 pl-0">
      <span class="font-weight-bold h5 videoTourDualListTitle">
        Lista de cámaras
      </span>

      <b-input-group class="w-100 my-1">
        <b-input-group-prepend is-text>
          <i class="feather icon-search"></i>
        </b-input-group-prepend>

        <b-form-input
          id="searchView"
          v-model="viewsSearchCamera"
          trim
          :placeholder="$t('search')"
          @input="onTypeSearchCamera"
        />
      </b-input-group>
      <div class="row mb-1">
        <div class="col">
          <v-select
            label="name"
            v-model="centerFilter"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="centerOptions"
            :reduce="(val) => val.id"
            input-id="id_center"
            placeholder="Buscar por centro"
            @input="changeCenter"
          />
        </div>
        <div class="col">
          <v-select
            label="name"
            v-model="sectorFilter"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="sectorOptions"
            :reduce="(val) => val.id"
            input-id="id_sector"
            placeholder="Buscar por sector"
          />
        </div>
        <div class="col">
          <v-select
            label="name"
            v-model="categoryFilter"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="categoryOptions"
            :reduce="(val) => val.id"
            input-id="id_category"
            placeholder="Buscar por categoría"
          />
        </div>
      </div>
      <b-list-group ref="refListGroup" class="mb-1 list-cameras">
        <b-list-group-item
          v-for="(cameraProxy, index) in visibleCameras"
          :key="index"
          class="d-flex justify-content-between align-items-center"
          button
          :disabled="selectCamerasDisabled"
          v-show="canShowCamera(cameraProxy)"
          @click="setCamera(cameraProxy)"
        >
          {{ cameraProxy.camera.name }}
          <div>
            <b-badge v-if="getDescriptionSector(cameraProxy.camera)" style="margin-right: 5px;">
              {{ getDescriptionSector(cameraProxy.camera) }}
            </b-badge>
            <b-badge v-if="getDescriptionUnit(cameraProxy.camera)" variant="primary">
              {{ getDescriptionUnit(cameraProxy.camera) }}
            </b-badge>
          </div>
        </b-list-group-item>
      </b-list-group>
      <pagination-widgets
        :sidebarMinWidthReached="false"
        :per-page.sync="camerasPerPage"
        :records-per-page="camerasPerPageOptions"
        :current-page.sync="camerasCurrentPage"
        :total-records="camerasProxyTotalRecords"
        @update:currentPage="updateCamerasCurrentPage"
        @update:perPage="updateCamerasPerPage"
      />
    </div>
    <div class="col-1 align-self-center text-center">
      <b-button
        variant="primary"
        class="p-0"
        :disabled="selectCamerasDisabled"
        @click="addAllCameras()"
      >
        <feather-icon
          icon="ChevronRightIcon"
          size="40"
        />
      </b-button>
      </div>
    <div class="col-6 align-self-start h-100">
      <span class="font-weight-bold h5 videoTourDualListTitle">
        Cámaras seleccionadas
      </span>
      <!-- {{ camerasSelected }} -->
      <b-alert
        v-if="!camerasSelected.length"
        show
        variant="warning"
        class="p-1 mt-1"
      >
        Sin cámaras seleccionadas
      </b-alert>
      <b-table
        v-else
        class="mt-1"
        :items="camerasSelected"
        :fields="fields"
        :sticky-header="heightCamerasSelectedTable"
      >
        <template #cell(camera.units)="data">
          {{ getDescriptionUnit(data.item.camera) }}
        </template>

        <template #cell(camera.sector)="data">
          {{ getDescriptionSector(data.item.camera) }}
        </template>

        <template #cell(actions)="data">
          <b-button
            variant="danger"
            size="sm"
            @click="removeCameraFromTable(data.item,data.index)"
          >
            <feather-icon icon="XIcon" />
          </b-button>
        </template>
      </b-table>
      <p v-if="errors.cameras" class="small text-danger">
        {{ errors.cameras }}
      </p>
    </div>
  </div>
</template>

<script>
import axios from "@axios";
import store from '@/store';
import { debounce } from "lodash";
import { computed,nextTick,ref,watch,onMounted } from '@vue/composition-api';
import PaginationWidgets from "../components/PaginationWidgets.vue";
import vSelect from "vue-select";

export default {
  props:{
    camerasSelected: {
      type: Array
    },
    currentPreviewSelected: {
      default: null
    },
    errors: {
      type: Object
    },
    fields: {
      type: Array
    },
    loadingLayoutSearch: {
      type: Boolean
    }
  },
  components:{
    PaginationWidgets,
    vSelect
  },
  setup (props, { emit }) {
    //HOOKS
    onMounted(async () => {
      await getCamerasProxy();

      store.dispatch('facility_category/getAll');

      const observer = new ResizeObserver(entries => {
        const height = entries[0].contentRect.height

        tableHeight.value = height;
      });

      if (refListGroup.value) {
        observer.observe(refListGroup.value)
      }
    });

    //DATA
    const camerasCurrentPage = ref(1);

    const camerasExcludedFilter = ref([]);

    const camerasPerPage = ref(4);

    const camerasProxy = ref([]);

    const camerasProxyTotalRecords = ref(0);

    const camerasSearch = ref('');

    const categoryFilter = ref(null);

    const centerFilter = ref(null);

    const loadingCameras = ref(false);

    const refListGroup = ref();

    const sectorFilter = ref(null);

    const sectorOptions = ref([]);

    const tableHeight = ref(0);

    const viewsSearchCamera = ref('');

    //COMPUTED
    const camerasPerPageOptions = computed(() => [
      (camerasPerPage.value * 1),
      (camerasPerPage.value + 4),
      (camerasPerPage.value + 8)
    ]);

    const heightCamerasSelectedTable = computed(() => (tableHeight.value <= 300) ? '300px' : `${tableHeight.value}px`);

    const categoryOptions = computed(() => store.getters['facility_category/getItems']);

    const centerOptions = computed(() => store.getters['center/getItems']);

    const selectCamerasDisabled = computed(() => (!props.currentPreviewSelected) || (loadingCameras.value) || (props.loadingLayoutSearch.value));

    const visibleCameras = computed(() => {
      return camerasProxy.value.filter(cameraProxy => {
        return !camerasExcludedFilter.value.includes(cameraProxy.id);
      });
    });

    //METHODS
    const addAllCameras = async () => {
      emit('clean-layout-items');

      camerasExcludedFilter.value = [];

      camerasProxy.value.forEach(camera => {
        setCamera(camera);
      });

      await getCamerasProxy();
    }

    const canShowCamera = (camera) => {
      const indexCamera = getCameraIndex(camera);

      return (indexCamera !== -1);
    }

    const changeCenter = (centerId) => {
      sectorFilter.value = null;

      const centerFiltered = centerOptions.value.find(
        center => center.id === centerId
      );

      sectorOptions.value = centerFiltered?.sectors || [];
    }

    const getCameraIndex = (dataCamera) => {
      if (!dataCamera) {
        return -1;
      }

      const index = props.camerasSelected.findIndex(
        camera => (camera.id === dataCamera.id)
      );

      return index;
    }

    const getCamerasProxy = async function () {
      loadingCameras.value = true;

      const params = {
        units: viewsSearchCamera.value,
        max: camerasPerPage.value,
        'page[n]': camerasCurrentPage.value,
        with: ['units'],
        camerasOnly: true,
        id_center: centerFilter.value,
        id_sector: sectorFilter.value,
        id_category: categoryFilter.value,
        camerasExcluded: camerasExcludedFilter.value
      }

      const { data } = await axios.get('v1/proxy_camera', { params });

      if (!data.success) return;

      camerasProxy.value = data.data.filter(cp => cp.camera);
      camerasProxyTotalRecords.value = data.meta.total;
      loadingCameras.value = false;
    }

    const getDescriptionSector = (camera) => {
      if (!camera.units.length) {
        return null;
      }

      const [unit] = camera.units;
      const { sector } = unit;

      if (!sector) {
        return null;
      }

      return sector.name;
    }

    const getDescriptionUnit = (camera) => {
      if (!camera.units.length) {
        return null;
      }

      const [unit] = camera.units;
      const { description } = unit;

      return description;
    }

    const onTypeSearchCamera = debounce(async function (search) {
      viewsSearchCamera.value = search;

      await getCamerasProxy();
    }, 800);

    const removeCameraFromTable = (camera) => {
      emit('remove-camera-from-table', camera);
    }

    const setCamera = (camera, isEdit = false, indexSlotEdit = null) => {
      const indexCamera = getCameraIndex(camera);
      const data = props.currentPreviewSelected.data;
      const slotsWithoutData = (props.camerasSelected.length < data.length);

      if ((indexCamera === -1) && slotsWithoutData) {
        if (camera) {
          props.camerasSelected.push(camera);
          camerasExcludedFilter.value.push(camera.id);
        }

        emit('find-slot-without-data', camera, isEdit, indexSlotEdit);
      }
    }

    const setCamerasProxyFromItem = async (perPage) => {
      camerasPerPage.value     = perPage;
      camerasCurrentPage.value = 1;

      await getCamerasProxy();
    }

    const updateCamerasCurrentPage = async (page) => {
      camerasCurrentPage.value = page;

      await getCamerasProxy();
    }

    const updateCamerasPerPage = async (perPage) => {
      camerasPerPage.value = perPage;
      await getCamerasProxy();
    }

    //WATCHERS
    watch(
      [centerFilter,sectorFilter,categoryFilter],
      async () => await getCamerasProxy()
    );

    /* watch(
      () => props.currentPreviewSelected,
      async () => {
        await nextTick();

        console.log(refListGroup.value.offsetHeight );
      },
      { immediate: true }
    ) */

    return {
      camerasCurrentPage,
      camerasExcludedFilter,
      camerasPerPage,
      camerasProxy,
      camerasProxyTotalRecords,
      camerasSearch,
      categoryFilter,
      centerFilter,
      loadingCameras,
      refListGroup,
      sectorFilter,
      sectorOptions,
      viewsSearchCamera,

      camerasPerPageOptions,
      categoryOptions,
      centerOptions,
      selectCamerasDisabled,
      visibleCameras,
      heightCamerasSelectedTable,

      addAllCameras,
      canShowCamera,
      changeCenter,
      getCamerasProxy,
      getDescriptionSector,
      getDescriptionUnit,
      onTypeSearchCamera,
      removeCameraFromTable,
      setCamera,
      setCamerasProxyFromItem,
      updateCamerasCurrentPage,
      updateCamerasPerPage
    }
  }
}
</script>
